import React from "react";
import FormikSelectField from "../fields/FormikSelectField";
import FormikTextField from "../fields/FormikTextField";
import { occupationOptions, regionOptions } from "../data/fieldOptions";

const ProfileStep = () => (
  <div className="step">
    <h3 className="main_question">
      <strong>2/4</strong>Perfil
    </h3>
    <FormikSelectField
      name="region"
      label="Región de residencia"
      placeholder="Selecciona tu región"
      options={regionOptions}
      required
    />
    <FormikSelectField
      name="occupation"
      label="Ocupación"
      placeholder="Selecciona tu ocupación (opcional)"
      options={occupationOptions}
    />
    <FormikTextField
      name="project_name"
      label="Nombre de tu emprendimiento o idea"
      placeholder="Escribe el nombre de tu emprendimiento o idea"
      required
    />
  </div>
);

export default ProfileStep;
